import { createSelector } from 'reselect';
import { getContentModelPublicAccessRules } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
// @ts-expect-error not yet migrated
import { getPostBodyImages } from 'ContentEditorUI/utils/helpers';
// @ts-expect-error not yet migrated
import { getModuleAndUploadedImages } from 'ContentEditorUI/redux/selectors/featuredImageSelectors';
import { getFakePostTitleModule, getFakePostBodyModule } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import { makeHublModuleElementManager } from 'tinymce-plugins/hsmoduleinsertion/utils/hubl';
import get from 'hs-lodash/get';
import { basicSelector, makeGatedSelector } from 'ContentEditorUI/redux/selectors/helpers';
import { getIsUngatedForImmerContentModel } from 'ContentEditorUI/redux/selectors/authSelectors';
import { unionSets } from 'ContentEditorUI/utils/set';
import { getImmutableOrPlain } from 'ContentEditorUI/utils/dataHelpers';
const getImmutablePostContentModel = basicSelector(state => state.contentModel);
const getImmerPostContentModel = basicSelector(state => state.contentModel);
export const getPostContentModel = makeGatedSelector(getIsUngatedForImmerContentModel, getImmutablePostContentModel, getImmerPostContentModel);
const createPostContentModelSelector = field => makeGatedSelector(getIsUngatedForImmerContentModel, createSelector([getPostContentModel.gated], contentModel => {
  return contentModel.get(field);
}), createSelector([getPostContentModel.ungated], contentModel => {
  return contentModel[field];
}));
export const getContentModelBlogAuthorId = createPostContentModelSelector('blogAuthorId');
export const getContentModelBlogAuthor = createPostContentModelSelector('blogAuthor');
export const getContentModelBlogAuthorAsJSObject = makeGatedSelector(getIsUngatedForImmerContentModel, createSelector([getContentModelBlogAuthor], blogAuthor => blogAuthor ? blogAuthor.toJS() : null), getContentModelBlogAuthor);
export const getContentModelContentGroupId = createPostContentModelSelector('contentGroupId');
export const getContentModelPreviewKey = createPostContentModelSelector('previewKey');
export const getContentModelTitle = createPostContentModelSelector('title');
export const getContentModelHtmlTitle = createPostContentModelSelector('htmlTitle');
export const getContentModelName = createPostContentModelSelector('name');
export const getContentModelTagIds = createPostContentModelSelector('tagIds');
export const getContentModelTagIdsAsJSObject = makeGatedSelector(getIsUngatedForImmerContentModel, createSelector([getContentModelTagIds], tagIds => tagIds ? tagIds.toJS() : null), getContentModelTagIds);
export const getContentModelTagList = createPostContentModelSelector('tagList');
export const getContentModelTagListAsJSObject = makeGatedSelector(getIsUngatedForImmerContentModel, createSelector([getContentModelTagList], tagList => tagList ? tagList.toJS() : null), getContentModelTagList);
export const getEnableGoogleAmpOutputOverride = createPostContentModelSelector('enableGoogleAmpOutputOverride');
export const getContentModelPostBody = createPostContentModelSelector('postBody');
export const getContentModelTextToAudioFileId = createPostContentModelSelector('textToAudioFileId');
export const getContentModelIsCrawlableByBots = createPostContentModelSelector('isCrawlableByBots');
export const getImagesFromPost = createSelector([getContentModelPostBody, getModuleAndUploadedImages], (postBody, uploadedImages) => unionSets(getPostBodyImages(postBody), uploadedImages));
export const getPostTitleFromFakeTitleModule = createSelector([getFakePostTitleModule], postTitleModule => {
  if (postTitleModule) {
    return postTitleModule.get('body').title;
  } else {
    return null;
  }
});
export const getPostBodyFromFakePostBodyModule = createSelector([getFakePostBodyModule], postBodyModule => {
  if (postBodyModule) {
    const fakePostBodyModuleBody = getImmutableOrPlain(postBodyModule, 'body');
    return getImmutableOrPlain(fakePostBodyModuleBody, 'html');
  } else {
    return null;
  }
});
export const getContentModelResolvedDomain = createPostContentModelSelector('resolvedDomain');
export const getContentModelHeadHtml = createPostContentModelSelector('headHtml');
export const getContentScheduledUpdateDate = createPostContentModelSelector('scheduledUpdateDate');
const getParentBlog = createPostContentModelSelector('parentBlog');
export const getContentModelParentBlogWallPreviewEnabled = createSelector([getContentModelPublicAccessRules, getParentBlog], (publicAccessRules, parentBlog) => get(publicAccessRules, [0, 'wallPreviewEnabled'], false) || get(parentBlog, ['publicAccessRules', 0, 'wallPreviewEnabled'], false));
export const getHasDuplicateModuleIds = createSelector([getContentModelPostBody], postBody => {
  const hublModuleElementManager = makeHublModuleElementManager(postBody);
  const postBodyModuleNames = new Set();
  const hasDuplicateModuleIds = hublModuleElementManager.getAll().reduce((anyDuplicates, module) => {
    const moduleName = module && module.info && module.info.name;
    if (postBodyModuleNames.has(moduleName)) {
      return true;
    }
    postBodyModuleNames.add(moduleName);
    return anyDuplicates || false;
  }, false);
  return hasDuplicateModuleIds;
});